import { FC } from "react";
import { Link, Outlet } from "react-router-dom";

import { Flex, Grid, theme } from "antd";

import { Logo } from "@components/Logo";
import { SidebarMenu } from "@components/SidebarMenu";
import { UserDropdown } from "@components/UserDropdown";
import usePermissions from "@hooks/usePermissions";

import { Content, Layout, RowContainer } from "./styles";
const { Sider, Header } = Layout;

export interface IPageLayoutProps {
  showSider?: boolean;
  showHeader?: boolean;
}

interface IRenderContentProps extends IPageLayoutProps {
  children?: React.ReactNode;
}

const SiderComponent = () => {
  return (
    <Sider width={260} breakpoint="sm" collapsedWidth="60" theme="light">
      <SidebarMenu />
    </Sider>
  );
};

const ContentComponent = ({
  showHeader,
  showSider,
  children,
}: IRenderContentProps) => {
  const { homeRoute } = usePermissions();
  const {
    token: { colorPrimary: colorBgHeader },
  } = theme.useToken();
  const screens = Grid.useBreakpoint();

  return (
    <>
      {showHeader && (
        <Header
          style={{
            height: 104,
            padding: "15px 0",
            backgroundColor: colorBgHeader || "transparent",
            position: "relative",
          }}
        >
          <RowContainer>
            <div className="logo-container">
              <Link to={homeRoute}>
                <Logo icon={screens.xs} type="white" />
              </Link>
            </div>
            <Flex flex={1}>
              <UserDropdown />
            </Flex>
          </RowContainer>
        </Header>
      )}

      <Layout>
        {showSider && <SiderComponent />}
        {children}
      </Layout>
    </>
  );
};

export const PageLayout: FC<IPageLayoutProps> = ({ showSider, showHeader }) => {
  return (
    <Layout>
      <ContentComponent showHeader={showHeader} showSider={showSider}>
        <Content>
          <Outlet />
        </Content>
      </ContentComponent>
    </Layout>
  );
};
